import { CheckmarkIcon, MoreIcon } from '@chegg-ui/theme'
import checkMark from '@src/assets/images/fanta-checkmark.svg'
import media from '@src/styled/media'
import styled from 'styled-components'
import { MenuItem } from '../styles'

export const CopyMenuItem = styled(MenuItem)`
  border-top: 1px solid ${({ theme }) => theme.colors.greyLight};
`

export const DownloadMenuItem = styled(MenuItem)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLight};
`

export const Upgrade = styled(MenuItem)`
  text-decoration: underline;
`

export const StyledMoreIcon = styled(MoreIcon)`
  margin-right: 2px;
`

export const StyledCheckmarkIcon = styled(CheckmarkIcon)`
  margin: -3px 0 -3px 23px;
`

export const TriggerIcon = styled(MoreIcon)`
  width: 24px;
  height: 24px;
  margin-right: 2px;
  margin-bottom: 2px;

  ${({ theme }) => media.phone`
    width: 2rem;
    height: 2rem;     
  `};

  &:hover {
    cursor: pointer;

    path {
      fill: ${props => props.theme.colors.cheggOrange};
    }
  }
`
export const FlagIcon = styled.img`
  height: 20px;
  width: 20px;
  border-radius: 50%;
`

export const LocaleText = styled.p`
  font-size: ${({ theme }) => theme.font.text.size.sm};
  margin: 0;
  padding: ${({ theme }) => theme.spacing.xs};
`

export const LocaleButton = styled.button<{ disabled?: boolean }>`
  border: none;
  background: none;
  box-sizing: content-box;
  display: flex;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xs};
  padding-left: ${({ theme }) => theme.spacing.md};
  width: 160px;
  cursor: pointer;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  &:hover {
    background-color: ${({ theme }) => theme.colors.skyXlight};
  }
`

export const Heading = styled.p`
  font-size: ${({ theme }) => theme.font.text.size.sm};
  color: ${({ theme }) => theme.colors.grey};
  font-weight: bold;
  width: 160px;
  padding-left: ${({ theme }) => theme.spacing.sm};
`

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`

export const CheckMark = styled.img.attrs({
  src: checkMark,
})`
  height: 16px;
  margin-left: 30px;
  margin-top: ${({ theme }) => theme.spacing.xs};
`



// WEBPACK FOOTER //
// ./src/layouts/shared/MoreActions/styles.tsx